import React, { ReactElement, useEffect, useState } from 'react';
import './Winners.scss';
import _ from 'lodash';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import Cookies from '../../assets/images/cookies.png';

interface PrizeList {
  schobot: Pick<any, string | number | symbol>[];
}

const Winners: React.FC = (): ReactElement => {
  const { t } = useTranslation();

  const [winners, setWinners] = useState<PrizeList>({
    schobot: [],
  });

  const getWinners = async () => {
    const res = await axios.get('/api/dataservice/winners/');

    // console.log(res);
    const prizes = _.mapValues(_.groupBy(res.data, 'prize'), (plist) =>
      plist.map((prize) => _.omit(prize, 'prize')),
    );

    setWinners({
      schobot: prizes.schobot === undefined ? [] : prizes.schobot,
    });
  };

  useEffect(() => {
    getWinners();
  }, []);

  return (
    <div className="winners">
      <h2>{t('winners')}</h2>
      <div className="winners-wrapper columns">
        <div className="column">
          <ul className={winners.schobot.length === 0 ? 'hidden' : ''}>
            {/* <li className="prize-name">Robottolmuimeja</li> */}
            {winners.schobot.map(function (item: any, index: any) {
              return (
                <li key={index}>{item.first_name + ' ' + item.last_name}</li>
              );
            })}
          </ul>
        </div>
      </div>
      <img src={Cookies} alt="domino cookies" className="cookies" />
    </div>
  );
};

export default Winners;
